import React, { useState, useEffect } from 'react';
import { useUser } from '../utils/auth';
import { MegaMenu } from '../components/MegaMenu';
import Footer from '../components/Footer';
import ProfileSection from '../components/dashboard/ProfileSection';
import SavedApplications from '../components/dashboard/SavedApplications';
import AppliedApplications from '../components/dashboard/AppliedApplications';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('profile');

  // Extract section from URL on component mount and when URL changes
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sectionParam = queryParams.get('section');
    
    if (sectionParam && ['profile', 'saved', 'applied'].includes(sectionParam)) {
      setActiveSection(sectionParam);
    } else if (!sectionParam && activeSection !== 'profile') {
      // If no section param, default to profile
      navigate('?section=profile', { replace: true });
    }
  }, [location.search]);

  // Update URL when active section changes
  const handleSectionChange = (section) => {
    setActiveSection(section);
    navigate(`?section=${section}`, { replace: true });
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return <ProfileSection />;
      case 'saved':
        return <SavedApplications />;
      case 'applied':
        return <AppliedApplications />;
      default:
        return <ProfileSection />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <MegaMenu background="bg-gray-800" />
      <div className="container mx-auto flex flex-col md:flex-row flex-1 py-16 px-4 mt-6 md:mt-16">
        {/* Sidebar */}
        <Sidebar activeSection={activeSection} setActiveSection={handleSectionChange} />

        {/* Main Content */}
        <div className="flex-1 md:ml-8">
          <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
            {renderContent()}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard; 